import { render, staticRenderFns } from "./DocumentModal.vue?vue&type=template&id=0ccc49ea&scoped=true&"
import script from "./DocumentModal.vue?vue&type=script&lang=ts&"
export * from "./DocumentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccc49ea",
  null
  
)

export default component.exports